import {CONFIGURE, NOTIFY, CLOSE} from "../../constants/Notifications";

export function configure(notification) {
    return {
        type: CONFIGURE,
        payload: {notification}
    };
};

function notify(severity, message) {
    const strMessage = typeof message === "object" ? JSON.stringify(message) : message;
    return {
        type: NOTIFY,
        payload: { severity, message: strMessage },
    };
};

export function notifySuccess(message) {
    return notify("success", message);
};

export function notifyWarning(message) {
    return notify("warning", message);
};

export function notifyInfo(message) {
    return notify("info", message);
};

export function notifyError(message) {
    return notify("error", message);
};

export function close() {
    return {
        type: CLOSE
    };
};